import { render } from "./EmotionDetail.vue?vue&type=template&id=04839210&scoped=true"
import script from "./EmotionDetail.vue?vue&type=script&lang=js"
export * from "./EmotionDetail.vue?vue&type=script&lang=js"

import "./EmotionDetail.vue?vue&type=style&index=0&id=04839210&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04839210"]])

export default __exports__